
import Vue from "vue";
import ProjectDetailsOverlay from "@/components/ProjectDetailsOverlay.vue";
import ProjectData from "@/data/ProjectData.ts";

export default Vue.extend({
  name: "ProjectsList",
  components: { ProjectDetailsOverlay },
  props: { projects: Array },
  data() {
    return {
      showPopup: false,
      popupTitle: "",
      popupColor: "",
      popupContent: "",
      popupIconUrl: ""
    };
  },
  computed: {
    featuredProject(): ProjectData | null {
      return (this.projects as ProjectData[]).find(p => p.isFeatured) || null;
    },
    regularProjects(): ProjectData[] {
      return (this.projects as ProjectData[]).filter(p => !p.isFeatured);
    }
  },
  methods: {
    showDetails(item: ProjectData) {
      this.popupTitle = item.name;
      this.popupColor = item.accentColor;
      this.popupContent = item.htmlDescription;
      this.popupIconUrl = item.iconUrl;
      this.showPopup = true;
      window.scrollTo(0, 0);
    }
  }
});
